import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Link, useParams } from "react-router-dom"

import { selectScopedByClient } from "../../stores/appSlice"
import { fetchGroupSupplyAccount, selectGroupSupplyAccount } from "./groupSupplyAccountsSlice"

export default function GroupSupplyAccountNav({ activeTab, scopedByGroupSupplyAccount = false }) {
    const dispatch = useDispatch()
    const { clientId, groupSupplyAccountId } = useParams()
    const groupSupplyAccount = useSelector(selectGroupSupplyAccount)
    const scopedByClient = useSelector(selectScopedByClient)

    // Fetch the groupSupplyAccount we need for breadcrumb
    // TODO: we may be able to simply swap this out for the use selector based
    // on how we decide to finally load in the records from other components.
    useEffect(() => {
        if (groupSupplyAccountId) {
            dispatch(fetchGroupSupplyAccount(groupSupplyAccountId))
        }
    }, [dispatch, groupSupplyAccountId])

    const formatRoute = (newRoute) => {
        if (clientId) {
            if (groupSupplyAccountId && scopedByGroupSupplyAccount) {
                return `/clients/${clientId}/group_supply_accounts/${groupSupplyAccountId}${newRoute}`
            } else {
                return `/clients/${clientId}/group_supply_accounts${newRoute}`
            }
        } else if (groupSupplyAccountId) {
            return `/group_supply_accounts/${groupSupplyAccountId}${newRoute}`
        }

        return `/group_supply_accounts${newRoute || ""}`
    }

    // If we are scoped by a client, we are looking at an end-user's view.
    // If we are not scoped by a client, we are looking at an admin's view.
    const renderHeader = () => {
        if (scopedByClient) {
            return scopedByGroupSupplyAccount ? renderRecordHeader() : renderIndexHeader()
        }

        // Admin - Not scoped by client here
        return (
            <>
                <h2>Group Supply Accounts</h2>
                <ul className="header-tab-nav" role="navigation">
                    <li>
                        <Link to={() => formatRoute("/")}>
                            <button type="link" className={`${activeTab === "list" ? "selected" : ""}`}>
                                All Group Supply Accounts
                            </button>
                        </Link>
                    </li>
                </ul>
            </>
        )
    }

    const renderRecordHeader = () => {
        return (
            <>
                <h2>
                    <Link to={() => `/clients/${clientId}/divisions/${groupSupplyAccount.division_id}/dashboard`}>{groupSupplyAccount.division_name} > </Link>
                    <Link to={() => `/clients/${clientId}/facilities/${groupSupplyAccount.facility_id}/dashboard`}>{groupSupplyAccount.facility_name} > </Link>
                    {`${groupSupplyAccount.name}`}    
                </h2>
                <ul className="header-tab-nav" role="navigation">
                    {/* Uknown if we need a dashboard for this page */}
                    {/* <li>
                        <Link to={() => formatRoute("/dashboard")}>
                            <button type="link" className={`${activeTab === "dashboard" ? "selected" : ""}`}>
                                Dashboard
                            </button>
                        </Link>
                    </li> */}

                    <li>
                        <Link to={() => formatRoute("/subaccounts")}>
                            <button type="link" className={`${activeTab === "subaccounts" ? "selected" : ""}`}>
                                Subaccounts
                            </button>
                        </Link>
                    </li>

                    <li>
                        <Link to={() => formatRoute("/bills")}>
                            <button type="link" className={`${activeTab === "bills" ? "selected" : ""}`}>
                                Bills
                            </button>
                        </Link>
                    </li>
                </ul>
            </>
        )
    }

    const renderIndexHeader = () => {
        return (
            <>
                <h2>Group Supply Accounts</h2>
                <ul className="header-tab-nav" role="navigation">
                    {/* Uknown if we need dashboard */}
                    {/* <li>
                        <Link to={() => formatRoute("/dashboard")}>
                            <button type="link" className={`${activeTab === "dashboard" ? "selected" : ""}`}>
                                Group Accounts Dashboard
                            </button>
                        </Link>
                    </li> */}
                    <li>
                        <Link to={() => formatRoute("")}>
                            <button type="link" className={`${activeTab === "list" ? "selected" : ""}`}>
                                All Group Supply Accounts
                            </button>
                        </Link>
                    </li>
                </ul>
            </>
        )
    }

    return <>{renderHeader()}</>
}
